import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { RouteComponentProps } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import {
  loginPlatformLegacy,
  LoginCredentials,
  useWistorAuth,
} from '../../api/auth'
import { LoginButtonBar, LoginPageLayout } from './LoginPageLayout'
import { SingleLoginView } from '../SingleLogin'

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i

export function Login(props: RouteComponentProps) {
  const auth = useWistorAuth()

  if (auth.status === 'authenticating') {

  }

  const redirectTo = typeof props.location.pathname === 'string' ? props.location.pathname : undefined

  return (
    <LoginPageLayout>
      <h1>Welcome to Wistor</h1>
      <SingleLoginView returnTo={redirectTo} />
      <LegacyLoginForm />
    </LoginPageLayout>
  )
}

function LegacyLoginForm() {
  const {
    register,
    handleSubmit,
    formState,
  } = useForm<LoginCredentials>()
  const history = useHistory()
  const [ errorReason, setErrorReason ] = useState<string | null>(null)

  const doLogin: SubmitHandler<LoginCredentials> = async loginCredentials => {
    setErrorReason(null)
    const resp = await loginPlatformLegacy(loginCredentials)

    if (!resp.success) return setErrorReason(resp.reason)

    if (window.location.pathname === '/login') {
      history.push('/')
    }
    window.location.reload()
  }

  return (
    <form onSubmit={handleSubmit(doLogin)}>
      <label>
        Username

        <input type="email" required
               className="font-normal"
               {...register('email', { required: true, pattern: EMAIL_PATTERN })} />
      </label>
      <label>
        Password

        <input type="password" required
               className="font-normal"
               {...register('password', { required: true })} />
      </label>

      <LoginButtonBar disabled={formState.isSubmitting}
                      isLoggingIn={formState.isSubmitting}
                      error={errorReason} />
    </form>
  )
}
